import React from 'react';
import { Star, Lock, Download, Timer } from 'lucide-react';
export function AnnouncementBar() {
  const badges = [{
    icon: Star,
    text: '+7.000 clientes'
  }, {
    icon: Lock,
    text: 'Pago 100% seguro'
  }, {
    icon: Download,
    text: 'Descarga inmediata'
  }, {
    icon: Timer,
    text: 'Oferta por tiempo limitado'
  }, {
    icon: Star,
    text: '🌎 Disponible para toda Latinoamérica'
  }];
  return <div className="fixed top-0 left-0 right-0 z-[60] h-10 bg-ink text-white overflow-hidden flex items-center" data-id="element-29">
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 hidden md:flex items-center justify-between" data-id="element-30">
        {badges.map((badge, index) => <div key={index} className="flex items-center gap-2 text-xs font-medium tracking-wide" data-id="element-31">
            <badge.icon className="w-3.5 h-3.5 text-gold" data-id="element-32" />
            <span data-id="element-33">{badge.text}</span>
          </div>)}
      </div>

      {/* Mobile Marquee */}
      <div className="md:hidden flex whitespace-nowrap animate-[marquee_20s_linear_infinite]" data-id="element-34">
        {[...badges, ...badges].map((badge, index) => <div key={index} className="flex items-center gap-1.5 text-[10px] font-medium tracking-wide mx-4" data-id="element-35">
            <badge.icon className="w-3 h-3 text-gold" data-id="element-36" />
            <span data-id="element-37">{badge.text}</span>
          </div>)}
      </div>
    </div>;
}